module.exports = __webpack_public_path__ + "img/jqqd.d4ee2291.svg";